import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '../app.service';
import { ApiResponse } from '../../models/commonModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpStatusCode } from '../../common/status-codes';
import { TokenConstants, ErrorMessageConstants } from '../../constants/message-constant';
import * as CryptoJS from 'crypto-js';
import { Observable, catchError, of, tap, Subject } from 'rxjs';
import { share } from 'rxjs/operators';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { AdminType } from 'src/app/enum/question-enum';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private errorMessage: string = "Something went wrong. Please try again after sometime.";
  setAutoHide: boolean = true;
  autoHide: number = 2000;
  private encryptionKey = CryptoJS.enc.Utf8.parse('EA34FF3E-JU84-1974-AW70-BB81D9564426');
  private salt = CryptoJS.enc.Base64.parse('SXZhbiBNZWR2ZWRldg==');
  private iterations = 100000;
  private CryptoAlgo = CryptoJS.algo.SHA512;
  private logoutSubject = new Subject<void>();
  public logoutAction$ = this.logoutSubject.asObservable();
  public href: any;
  private KEY = "c604f199ff095b4ced4caf373264e84045f71b384ce39628ee8adca2b27109e8";
  private IV = "47b5b25d579c0bed815c9166b4f37ee8";
  isSystemAlert: boolean = false;
  constructor(private router: Router, private ModalService: NgbModal, private spinner: NgxSpinnerService, private toster: ToastrService, private appService: AppService, private http: HttpClient, private api: ApiUrlHelper) {
  }

  DownloadCSVFile(apiUrl: String, postData: any): Observable<any> {
    const url = `${environment.BaseURL}${apiUrl}`;
    return this.http.post<Blob>(url, postData,
      {
        responseType: 'blob' as 'json',
        headers: new HttpHeaders(
          {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, DELETE, PUT',
            'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
          })
      });
  }

  GetDownloadCSVFile(apiUrl: String): Observable<any> {
    const url = `${environment.BaseURL}${apiUrl}`;
    return this.http.get<Blob>(url,
      {
        responseType: 'blob' as 'json',
        headers: new HttpHeaders(
          {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, DELETE, PUT',
            'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
          })
      });
  }

  DownloadPDFFile(apiUrl: string): Observable<Blob> {
    const url = `${environment.BaseURL}${apiUrl}`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
    });

    return this.http.get<Blob>(url, {
      responseType: 'blob' as 'json',
      headers: headers,
    }).pipe(
      share() // Add the share operator here if needed
    );
  }

  DownloadPDFFilePost(apiUrl: string, postData: any): Observable<Blob> {
    const url = `${environment.BaseURL}${apiUrl}`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
    });

    return this.http.post<Blob>(url, postData,
      {
        responseType: 'blob' as 'json',
        headers: headers,
      }).pipe(
        share() // Add the share operator here if needed
      );
  }

  doDownloadCSVPost(apiUrl: string, postData: any) {
    const httpOptions = {
      headers: new HttpHeaders()
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + loginData);
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', '*');
    }
    return this.http.post(`${environment.BaseURL}${apiUrl}`, postData, { headers: httpOptions.headers, observe: "response", responseType: "blob" });
  }
  doGet(apiUrl: String): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders()
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + loginData);
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Origin', '*');
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
    }
    const url = `${environment.BaseURL}${apiUrl}`;
    return this.http.get<ApiResponse>(url, httpOptions).pipe(
      tap(() => this.log(`doGet success`)),
      catchError(this.handleError<ApiResponse>(
        `doGet url = ${JSON.stringify(apiUrl)}`,
        {
          data: null, message: this.errorMessage, success: false, TAID: 0, status: 0
        })
      )
    );
  }

  doPost(apiUrl: string, postData: any): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders(
      )
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + loginData);
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Origin', '*');
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
    }
    const url = `${environment.BaseURL}${apiUrl}`;
    return this.http.post<ApiResponse>(url, postData, httpOptions).pipe(
      tap(() => this.log(`doGet success`)),
      catchError(this.handleError<ApiResponse>(
        `doGet url = ${JSON.stringify(apiUrl)}`,
        {
          data: null, message: this.errorMessage, success: false, TAID: 0, status: 0
        })
      )
    );
  }

  doPut(apiUrl: string, putData: any): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders(
      )
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + loginData);
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Origin', '*');
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
    }
    const url = `${environment.BaseURL}${apiUrl}`;
    return this.http.put<ApiResponse>(url, putData, httpOptions).pipe(
      tap(() => this.log(`doGet success`)),
      catchError(this.handleError<ApiResponse>(
        `doGet url = ${JSON.stringify(apiUrl)}`,
        {
          data: null, message: this.errorMessage, success: false, TAID: 0, status: 0
        })
      )
    );
  }

  doDelete(apiUrl: String, idtoDelete: number): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders(
      )
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + loginData);
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Origin', '*');
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
    }
    const options = {
      headers: httpOptions.headers,
      body: {
        UserId: idtoDelete
      }
    };
    const url = (`${environment.BaseURL}${apiUrl}`);
    return this.http.delete<ApiResponse>(url, httpOptions).pipe(
      tap(() => this.log(`doGet success`)),
      catchError(this.handleError<ApiResponse>(
        `doGet url = ${JSON.stringify(apiUrl)}`,
        {
          data: null, message: this.errorMessage, success: false, TAID: 0, status: 0
        })
      )
    );
  }

  doDownload(apiUrl: string, isWithBaseURL: boolean) {
    const httpOptions = {
      headers: new HttpHeaders()
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + loginData);
      httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', '*');
    }
    let url = '';
    if (!isWithBaseURL) {
      url = `${environment.BaseURL}${apiUrl}`;
    }
    else {
      url = `${apiUrl}`;
    }
    return this.http.get(url, { headers: httpOptions.headers, observe: "response", responseType: "blob" });
  }
  // Check Authorize Role
  checkAuthorize(error: { status: number; error: { title: null; message: null; }; message: any; }) {
    if (error.status == HttpStatusCode.Unauthorized) {
      if (error.error && error.error.title) {
        var errorMessage = (error.error.title != null) ? error.error.title : error.message;
        this.toster.error(errorMessage);
      }
      this.router.navigate(['/unauthorized']);
    }
    else if (error.status == HttpStatusCode.Forbidden) {
      if (error.error && error.error.title) {
        var errorMessage = (error.error.title != null) ? error.error.title : error.message;
        this.toster.error(errorMessage);
      }
      this.appService.logout();
      this.toster.error(TokenConstants.Session_Expired);
      this.spinner.hide();
      this.ModalService.dismissAll();
    }
    else if (error.status === HttpStatusCode.InternalServerError) {
      var errorMessage: any = ErrorMessageConstants.Message;
      this.toster.error(errorMessage);
    }
    else {
      var errorMessage = (error.error.message != null) ? error.error.message : error.message
    }
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      this.checkAuthorize(error);
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
  }

  // Check form value changed or not
  onFormValueChange(status: any, initalValues: any, form: { [x: string]: any; }): boolean {
    if (!status) {
      var formUnchanged = false;
      const initialValue = initalValues;
      if (JSON.stringify(form) !== JSON.stringify(initialValue)) {
        formUnchanged = true;
      }
      return formUnchanged;
    }
    else {
      return false
    }
  }

  companyWebsiteValidator(): ValidatorFn {
    const websitePattern = /^(https?:\/\/|www\.)/i;
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value && !websitePattern.test(value)) {
        return { invalidCompanyWebsite: true };
      }
      return null;
    };
  }

  //space validation for 
  space(event: any) {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault();
    }
  }

  //Deafult page redirection
  defaultPageRedirection(currentUserRole: any) {
    switch (currentUserRole) {
      case AdminType.SuperAdmin:
        this.router.navigate(['/user']);
        break;
      case AdminType.CompanyAdmin:
        this.router.navigate(['/college-batch']);
        break;
      case AdminType.Admin:
        this.router.navigate(['/user']);
        break;
      case AdminType.HR:
        this.router.navigate(['/user']);
        break;
      case AdminType.Receptionist:
        this.router.navigate(['/user']);
        break;
      default:
        this.router.navigate(['/unauthorized']);
        break;
    }
  }
  //this function will be in use only if you change the encryptionKey,
  //so next time call this functin from somewhere and generate KEY and IV and replace with current one.
  generateKEYNIV() {
    const keyAndIv = CryptoJS.PBKDF2(this.encryptionKey, this.salt, { keySize: 256 / 32 + 128 / 32, iterations: this.iterations, hasher: this.CryptoAlgo }); // so PBKDF2 in CryptoJS is direct in that it
    // always begins at the beginning of the password, whereas the .net
    // implementation offsets by the last length each time .GetBytes() is called
    // so we had to generate a Iv + Salt password and then split it
    const hexKeyAndIv = CryptoJS.enc.Hex.stringify(keyAndIv);
    const stringKEY = hexKeyAndIv.substring(0, 64);
    this.KEY = stringKEY;
    const stringIV = hexKeyAndIv.substring(64, hexKeyAndIv.length);
    this.IV = stringIV;
  }
  public Decrypt(cipherText: string): string {
    const KEY = CryptoJS.enc.Hex.parse(this.KEY);
    const IV = CryptoJS.enc.Hex.parse(this.IV);
    // As you're using Encoding.Unicde in .net, we have to use CryptoJS.enc.Utf16LE here.
    let decrypt = CryptoJS.AES.decrypt(cipherText, KEY, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8).toString();
    return decrypt.replaceAll("\x00", "").replaceAll(/&quot;/g, '"');
  }
}
